const mySubscriptionRoutes = [

    {
        path: '/my-subscription',
        name: 'MySubscriptionPage',
        component: () => import('../views/mySubscription/MySubscriptionComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['ADMIN'],
            module: 'mySubscription',
        },
    },

];

export default mySubscriptionRoutes;
